import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rds-c-variable-information-decorators',
  templateUrl: './variable-information-decorators.component.html',
  styleUrls: ['./variable-information-decorators.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsVariableInformationDecoratorsComponent {
  static ngAcceptInputType_measure: BooleanInput;
  static ngAcceptInputType_required: BooleanInput;
  static ngAcceptInputType_weight: BooleanInput;

  @Input()
  get measure() {
    return this._measure;
  }
  set measure(value: boolean) {
    this._measure = coerceBooleanProperty(value);
  }
  private _measure = false;

  @Input()
  get required() {
    return this._required;
  }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
  }
  private _required = false;

  @Input()
  get weight() {
    return this._weight;
  }
  set weight(value: boolean) {
    this._weight = coerceBooleanProperty(value);
  }
  private _weight = false;
}
